<div class="d-flex justify-content-between align-items-center mb-2">
  <p class="text-secondary small mb-0">{{ resumoQuantidade() }}</p>
</div>

<div class="table-responsive">
  <table class="table table-sm table-hover align-middle">
    <thead>
      <tr>
        <th>Data/hora</th>
        <th>Empregador</th>
        <th>Tipo</th>
        <th>Origem</th>
        <th>Status</th>
        <th>IP</th>
        <th>Descricao</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let evento of eventos">
        <td class="text-nowrap">{{ evento.criadoEm | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ evento.empregador || '-' }}</td>
        <td class="text-nowrap">{{ rotuloTipo(evento.tipo) }}</td>
        <td>{{ evento.origem || '-' }}</td>
        <td>
          <span class="badge" [ngClass]="evento.sucesso ? 'text-bg-success' : 'text-bg-danger'">
            {{ evento.sucesso ? 'Sucesso' : 'Falha' }}
          </span>
        </td>
        <td class="text-nowrap">{{ evento.ipOrigem || '-' }}</td>
        <td class="descricao-auditoria">{{ evento.descricao || '-' }}</td>
        <td class="text-nowrap">
          <button
            *ngIf="podeVerCaptura(evento)"
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="verCaptura.emit(evento)">
            <i class="bi bi-camera px-1"></i>
            Ver captura
          </button>
        </td>
      </tr>
      <tr *ngIf="!carregando && eventos.length === 0">
        <td colspan="8" class="text-secondary">Nenhum evento encontrado para os filtros selecionados.</td>
      </tr>
      <tr *ngIf="carregando">
        <td colspan="8" class="text-secondary">Carregando eventos...</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="d-flex flex-wrap gap-2 justify-content-between align-items-center" *ngIf="totalPaginas > 1">
  <span class="text-secondary small">Pagina {{ pagina }} de {{ totalPaginas }}</span>
  <div class="btn-group">
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      [disabled]="carregando || pagina <= 1"
      (click)="paginaChange.emit(pagina - 1)">
      Anterior
    </button>
    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      [disabled]="carregando || pagina >= totalPaginas"
      (click)="paginaChange.emit(pagina + 1)">
      Proxima
    </button>
  </div>
</div>
